<template>
  <div class="container-details">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- 公共头部 -->
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!--详情内容-->
    <div class="detail-info">
      <div class="detail-title">{{ infoData.informationTitle }}</div>
      <div v-if="infoData.videoUrl" class="video-cont">
        <video controls style="width:100%;" poster="../../assets/images/video-poster03.png">
          <source :src="defaultPath+infoData.videoUrl" type="video/mp4"/>
        </video>
      </div>
      <div class="detail-desc" v-html="infoData.informationContent"></div>
      <div class="detail-clicks">阅读量：{{ infoData.visitNum }}</div>
    </div>
    <!--详情内容-->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";
import {getAlumniInformationInfo} from "@/apis/apis.js";

export default {
  name: "AlumniDetail",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      imgUrl: "http://file.hainayx.com/file-server/download?fileUrl=",
      defaultPath: 'https://cdn.yzvet.com/',
      infoData: {}, // 详情页数据
    };
  },
  methods: {
    /* 获取详情页 */
    async getAlumniInformationInfo(id) {
      try {
        let params = {
          id: id
        };
        let {data} = await getAlumniInformationInfo(params);
        this.infoData = data.data;
      } catch (err) {
      }
    },
  },
  mounted() {
    this.id = this.$route.query.id; //获取列表页传递过来的ID
    if (this.id) {
      this.getAlumniInformationInfo(this.id);
    }
  }
};
</script>

<style lang="less">
.banner-info {
  width: 100%;
  height: 200px;
  background: url('../../assets/images/banner002.png');
  background-size: 100% 100%;
}

.detail-info {
  width: 95%;
  margin: 0 auto 50px auto;

  .video-cont {
    margin: 30px 0;
  }

  .detail-title {
    color: #E58111;
    padding-top: 30px;
    font-size: 39px;
    line-height: 60px;
  }

  .detail-desc {
    padding-top: 30px;
    padding-bottom: 30px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .detail-clicks {
    margin-bottom: 10px;
    font-size: 28px;
    color: #333;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/alumni-style/alumniDetail.vue